import React, { Component } from "react";
import { themeClass, headerSuffix } from "~/store/actions";
import { connect } from "react-redux";
import { pageMapStateToProps } from "~/store/mappers";
import axios from "axios";
import Volby2026OsoPage from "~/components/pages/Volby2026OsoPage";
import { BASE_URL } from "~/utility/volby2026";

const POLL_INTERVAL = 60000;

class PageVolby2026Oso extends Component<any, any> {
  pollTimer: ReturnType<typeof setInterval> | null = null;

  constructor(props) {
    super(props);
    this.state = {
      legend: {},
      results: {},
    };
  }

  update(props) {
    const { dispatch } = props;
    dispatch(headerSuffix("Voľby 2026", "/volby-2026"));
    dispatch(themeClass("theme_prave-teraz"));
  }

  fetchResults = () => {
    axios
      .get(`${BASE_URL}/oso_results.json`)
      .then((res) => this.setState({ results: res.data }))
      .catch(() => {});
  };

  UNSAFE_componentWillMount() {
    this.update(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.update(nextProps);
  }

  componentDidMount() {
    this.update(this.props);

    axios
      .get(`${BASE_URL}/oso_legend.json`)
      .then((res) => this.setState({ legend: res.data }))
      .catch(() => {});

    this.fetchResults();
    this.pollTimer = setInterval(this.fetchResults, POLL_INTERVAL);
  }

  componentWillUnmount() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  }

  render() {
    const { legend, results } = this.state;
    return <Volby2026OsoPage legend={legend} results={results} />;
  }
}

export default connect(pageMapStateToProps)(PageVolby2026Oso);
